import UserProfile from "../home/userProfile";
import MBTIForm from "./MBTIForm";

export default function MBTIPage() {
	return (
		<div className="container mbti-page-container">
			<div className="main-container mbti-form-container">
				<MBTIForm />
			</div>

			<UserProfile />
		</div>
	);
}
